import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

export function getCustomPaginatorIntl(translate: TranslateService) {
  const paginatorIntl = new MatPaginatorIntl();

  paginatorIntl.itemsPerPageLabel = translate.instant('Leads per page');

  return paginatorIntl;
}
